import { createContext } from "react";
import type { TripsClientAssetProps } from "@hopper-b2b/types";

/**
 * Trips client asset context.
 *
 * Defined in its own leaf module (rather than inside App.tsx) so that
 * presentational components can consume it without importing the full trips
 * `App` tree. App.tsx imports the Provider from here and re-exports the context
 * for backwards compatibility; this avoids component <-> container import
 * cycles that break isolated rendering (e.g. the Storybook test runner).
 */
export const ClientContext = createContext<Partial<TripsClientAssetProps>>({});
